import ChipCardItem from 'components/services/ChipCardItem';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Linking } from 'react-native';
import { Pmc } from 'types/generatedSchemaTypes';
import { testIdentifiers } from 'utils/testIdentifiers';
import { MyPermitCardOptions, PermitCardLeftComponent } from './MyPermitCard';

const LoyaltyAdvertisementCard = (pmc: Pmc, options?: MyPermitCardOptions) => {
  const { t } = useTranslation();

  const handlePress = () => {
    if (pmc.link) {
      Linking.openURL(pmc.link).catch((err) =>
        console.error('Failed to open loyalty URL:', err)
      );
    }
  };

  const { id } = pmc;

  const title = useMemo(() => {
    return pmc.name;
  }, [pmc]);

  const LeftComponent = useCallback(() => {
    return (
      <PermitCardLeftComponent
        isWaitingActivation={false}
        id={id ?? ''}
        logo={pmc?.logo}
        permitType={pmc?.permitType}
      />
    );
  }, [id, pmc]);

  return (
    <ChipCardItem
      title={title ?? 'Permit'}
      label={
        options?.showLabel ? t('permit.unboughtLoyaltyMembership') : undefined
      }
      LeftComponent={LeftComponent}
      onPress={handlePress}
      {...testIdentifiers('my-permit-chip-card')}
      showExternalLinkIcon={true}
    />
  );
};

export default LoyaltyAdvertisementCard;
